import { get, patch, post } from '@aiptyg/api-client';
import type {
  DownloadOnlyTaskUserDTO,
  DownloadOnlyTaskUserListParams,
  DownloadOnlyTaskUserListResponseDTO,
  DownloadOnlyTaskUserRefreshResponseDTO,
  DownloadOnlyTaskUserShowNormalTasksUpdateDTO,
} from './types';

export function listDownloadOnlyTaskUsers(params: DownloadOnlyTaskUserListParams): Promise<DownloadOnlyTaskUserListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.userId.trim()) qs.set('user_id', params.userId.trim());
  if (params.keyword.trim()) qs.set('keyword', params.keyword.trim());
  if (params.accountKeyword.trim()) qs.set('account_keyword', params.accountKeyword.trim());
  if (params.nameKeyword.trim()) qs.set('name_keyword', params.nameKeyword.trim());
  if (params.targetHash.trim()) qs.set('target_hash', params.targetHash.trim());
  return get<DownloadOnlyTaskUserListResponseDTO>(`/v1/admin/download-only-task-users?${qs.toString()}`);
}

export function refreshDownloadOnlyTaskUsers(): Promise<DownloadOnlyTaskUserRefreshResponseDTO> {
  return post<DownloadOnlyTaskUserRefreshResponseDTO>('/v1/admin/download-only-task-users/refresh', {});
}

export function updateDownloadOnlyTaskUserShowNormalTasks(userId: number, payload: DownloadOnlyTaskUserShowNormalTasksUpdateDTO): Promise<DownloadOnlyTaskUserDTO> {
  return patch<DownloadOnlyTaskUserDTO>(`/v1/admin/download-only-task-users/${userId}/show-normal-tasks`, { ...payload });
}
